// Docker licensing — see documentation/STAGING-Docker-Licensing.md

// Only the FenxLabs-hosted portal build sets this; client Docker images build without it.
export const licenceAdminEnabled = process.env.REACT_APP_ENABLE_LICENCE_ADMIN === 'true';

// Mirrors the backend's fenxlabsAdminOnly: admin flag AND @fenxlabs.ai email.
export function canManageLicences(user: { isAdmin?: boolean; email?: string } | null | undefined): boolean {
  return licenceAdminEnabled && !!user?.isAdmin && !!user?.email?.toLowerCase().endsWith('@fenxlabs.ai');
}
